import React, { useMemo } from 'react';
import { getLocalTimeStringForState, isWithinBusinessHours } from '@utils/inspectionUtils';

type Props = {
  saleState?: string;
};

const SellerLocalTimeNotice: React.FC<Props> = ({ saleState }) => {
  const isSellerWithinBusinessHours = useMemo(
    () => isWithinBusinessHours(saleState),
    [saleState]
  );
  return (
    !isSellerWithinBusinessHours ? (
    <div className="border border-blue-200 bg-blue-50 rounded-lg px-4 py-3 mt-2 font-inter">
      <p className="text-sm font-semibold font-inter text-blue-900 mb-2">
        Seller Local Time Notice
      </p>
      <p className="text-sm font-regular font-inter text-blue-700 mb-4">
        The seller&apos;s current local time is:{' '}
        <br />
        <span className="font-semibold text-blue-900 font-inter">
          {getLocalTimeStringForState(saleState)}
        </span>
        .
      </p>
      <p className="text-sm font-regular font-inter text-blue-700">
        Please consider whether this is a suitable time for the seller to
        receive an SMS invitation.
      </p>
    </div>
  ) : null
  );
};

export default SellerLocalTimeNotice;
